/**
 * Drops elements from the end of an array
 */
export const dropRight = <T>(array: T[], n: number): T[] => {
  return n === 0 ? [...array] : array.slice(0, -n)
}
